import ShellFooter from './ShellFooter';
import { FIXED_FOOTER_ID } from './constants';

export default ShellFooter;
export { FIXED_FOOTER_ID };
